import styles from "./SocialLink.module.css";

const SocialLink = (props) => {
  return (
    <a href={props.href} className={`${styles.link} ${props.linkClassName}`}>
      <img
        src={props.src}
        alt={props.alt}
        className={`${styles.img} ${props.imgClassName}`}
      />
    </a>
  );
};

export default SocialLink;
